export enum BookingType {
    Reservation = 'reservation',
    Booking = 'booking',
}
